import React from 'react';
import { motion } from 'framer-motion';
import { Rocket, Zap, Clock, Lightbulb, ShieldCheck } from 'lucide-react';
export function IdentitySection() {
  const identities = [{
    icon: <Rocket className="w-8 h-8 text-cyan-400" data-id="element-121" />,
    title: 'El Profesional del Futuro',
    description: 'Dominas la tecnología en lugar de temerle. Mientras otros se asustan, tú tomas ventaja.'
  }, {
    icon: <Zap className="w-8 h-8 text-yellow-400" data-id="element-122" />,
    title: 'El Más Productivo de la Sala',
    description: 'La persona a la que todos preguntan: "¿Cómo diablos lo haces tan rápido?".'
  }, {
    icon: <Clock className="w-8 h-8 text-green-400" data-id="element-123" />,
    title: 'Dueño de tu Tiempo',
    description: 'Terminas tu jornada laboral antes y disfrutas tu vida. Adiós a las horas extra no pagadas.'
  }, {
    icon: <Lightbulb className="w-8 h-8 text-purple-400" data-id="element-124" />,
    title: 'Un Estratega Innovador',
    description: 'Dejas de ser un ejecutor de tareas repetitivas para enfocarte en las ideas que generan dinero.'
  }, {
    icon: <ShieldCheck className="w-8 h-8 text-blue-500" data-id="element-125" />,
    title: 'Irremplazable',
    description: 'Te blindas contra la crisis y la obsolescencia. Tu valor profesional se multiplica.'
  }];
  return <section className="py-24 relative overflow-hidden bg-[#050505]" data-id="element-126">
      {/* Elementos decorativos de fondo */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-blue-600/5 blur-[120px] rounded-full pointer-events-none" data-id="element-127" />

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-129">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-130">
            TU NUEVA <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-600" data-id="element-131">VERSIÓN PROFESIONAL</span>
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-132">
            No es solo un libro, es una actualización de tu software mental.
          </p>
        </motion.div>

        <div className="grid gap-6" data-id="element-133">
          {identities.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: "-50px"
        }} transition={{
          delay: index * 0.15
        }} className="group flex flex-col md:flex-row items-start md:items-center gap-6 p-6 md:p-8 rounded-2xl bg-white/5 border border-white/10 hover:border-cyan-500/50 hover:bg-white/10 transition-all duration-300" data-id="element-134">
              {/* Icono con fondo brillante */}
              <div className="flex-shrink-0 p-4 rounded-xl bg-black/40 border border-white/5 shadow-lg group-hover:scale-110 transition-transform duration-300" data-id="element-135">
                {item.icon}
              </div>

              {/* Textos */}
              <div className="flex-1" data-id="element-136">
                <h3 className="text-xl md:text-2xl font-bold text-white mb-2 group-hover:text-cyan-300 transition-colors" data-id="element-137">
                  {item.title}
                </h3>
                <p className="text-gray-400 text-base md:text-lg leading-relaxed" data-id="element-138">
                  {item.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}